import React from "react";
import tw from "tailwind-styled-components";
import { IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";

function DashboardMetrics({ data }) {
  const navigate = useNavigate();
  const metrics = [
    { label: "Owners", value: data?.totalOwners, link: "/owners" },
    { label: "Inventories", value: data?.totalInventory, link: "/inventory/operational" },
    { label: "For Rent", value: data?.forRent, link: "/inventory/operational" },
    { label: "For Sale", value: data?.forSale, link: "/inventory/operational" },
    { label: "Active", value: data?.activeDeals, link: "/deals/pipeline", color: "text-green-600" },
    { label: "Active Lease", value: data?.activeLease, link: "/inventory/operational", color: "text-amber-600" },
    { label: "Closed", value: data?.closedDeals, link: "/deals/closed", color: "text-sky-600" },
    // { label: "Vacant Beds", value: data?.vacantBeds, link: "/vacancy-by-property", color: "text-rose-600" },
  ];

  return (
    <Container>
      <MetricsRow>
        <MetricsScroll>
          {metrics.map((item, index) => (
            <Metric
              key={index}
              onClick={() => navigate(item.link)}
            >
              <MetricLabel>{item.label}</MetricLabel>

              <MetricValue className={item.color || "text-gray-900"}>
                {item.value ?? 0}
                <Arrow />
              </MetricValue>
            </Metric>
          ))}
        </MetricsScroll>
      </MetricsRow>
      <ContextNote>
        Date filter does not affect these values.
      </ContextNote>
    </Container>
  );
}

const Container = tw.div`
  mt-2 md:mt-6 px-4 py-2 md:px-6 md:py-4
  bg-white rounded-lg shadow-sm
`;

const MetricsScroll = tw.div`
  flex gap-2
  overflow-x-auto
  scrollbar-hide
  justify-end
  pb-1
  grid md:grid-cols-7 xl:grid-cols-7 grid-cols-4
`;

const Metric = tw.div`
  min-w-[110px]
  flex-shrink-0
  cursor-pointer
  group
`;

const MetricLabel = tw.div`
  text-[9px] md:text-[11px] uppercase tracking-wide text-gray-500
  whitespace-nowrap
`;

const MetricValue = tw.div`
  flex items-center gap-1
  text-lg font-semibold
  transition-colors
`;

const Arrow = tw(IoIosArrowForward)`
  text-gray-400 text-xs
  opacity-0 group-hover:opacity-100
  transition-opacity
`;

const MetricsRow = tw.div`
  flex
`;

const ContextNote = tw.div`
  mt-0
  -mb-2
  pr-0
  text-[10px]
  text-gray-300
  text-right
  hidden lg:block
  leading-tight
`;


export default DashboardMetrics;